import clsx from 'clsx';
import styles from './ArrangeQuestion.module.scss';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { TextButton, ResultBox, IconButton } from '~/components';
import { v4 as uuidv4 } from 'uuid';
import {
    countOccurrencesInArray,
    getTypeOfResult,
    handleVibrate,
    processString,
    shuffleArray,
} from '~/utils/common';
import { ArrangeBox } from '~/components';
import { useTranslation } from 'react-i18next';
import { handleTextToHtml } from '~/utils/string';

const splitAnswer = (arr, confusedList) => {
    let lsFinal = [];
    arr.forEach((text) => {
        const lsTemp = processString(text, false).split(' ');
        lsTemp.forEach((item) => {
            const countItem = countOccurrencesInArray(item, lsTemp);
            const countItemInFinal = countOccurrencesInArray(item, lsFinal);
            if (countItem > countItemInFinal) {
                for (let i = countItemInFinal; i < countItem; i++) {
                    lsFinal.push(item);
                }
            }
        });
    });
    if (confusedList && Array.isArray(confusedList))
        lsFinal = [...lsFinal, ...confusedList];
    return shuffleArray(lsFinal);
};

const createGivenList = (arr) => {
    let ls = [];
    arr.forEach((text) => {
        ls.push({
            id: uuidv4(),
            text,
            gone: false,
        });
    });
    return shuffleArray(ls);
};
function ArrangeQuestion(
    {
        question,
        audioMap,
        notiCompleteAnAnswer,
        updateResult,
        className,
        handlePlay,
        handlePlayByWords,
        handleStop,
        ...rest
    },
    ref,
) {
    const { t } = useTranslation();
    const [result, setResult] = useState('wrong'); // no_check || right || wrong
    const [isShowResult, setIsShowResult] = useState(false);

    const [givenList, setGivenList] = useState([]);
    const [answerList, setAnswerList] = useState([]);

    const [answerHeight, setAnswerHeight] = useState(100);
    const givenDivRef = useRef(null);

    function findResult() {
        let kq = false;
        console.log('answerList', answerList);
        const userAnswer = processString(
            answerList.reduce((str, ele) => str + ' ' + ele.text, ''),
        );
        console.log('userAnswer', userAnswer);
        for (let i = 0; i < question.answer.length; i++) {
            const rightAnser = processString(question.answer[i]);
            console.log('rightAnser', rightAnser);
            if (rightAnser === userAnswer) {
                kq = true;
                break;
            }
        }
        return { count: 1, correct: kq ? 1 : 0 };
    }

    const handleOnClickCheck = () => {
        const kqTam = findResult();
        const type = getTypeOfResult(kqTam);
        notiCompleteAnAnswer(type);
        setResult(type);
        handleVibrate('strong');
        setIsShowResult(true);
    };

    const handleOnClickContinue = () => {
        updateResult({ count: 1, correct: result === 'right' ? 1 : 0 }, true);
    };

    const handleOnClickGivenBox = (box) => {

        if (!box.gone) {
            setGivenList((pre) => {
                return pre.map((ele) => {
                    if (ele.id === box.id) {
                        return { ...ele, gone: true };
                    } else return ele;
                });
            });
            setAnswerList((pre) => {
                return [...pre, box];
            });
        }
        if (handlePlay)
            handlePlay(box.text)
    };

    const handleOnClickAnswerBox = (box) => {
        setGivenList((pre) => {
            return pre.map((ele) => {
                if (ele.id === box.id) {
                    return { ...ele, gone: false };
                } else return ele;
            });
        });
        setAnswerList((pre) => {
            return pre.filter((ele) => ele.id !== box.id);
        });
    };

    // Mỗi lần hiện result
    const hiddenInputRef = useRef(null);
    const resultDivRef = useRef(null);

    useEffect(() => {
        if (isShowResult) {
            // focus vào input ẩn để bắt sự kiện phím
            if (hiddenInputRef.current) {
                hiddenInputRef.current.focus();
            }
            // scroll đến div result
            if (resultDivRef.current) {
                resultDivRef.current.scrollIntoView();
            }
        }
    }, [isShowResult]);

    // Mỗi khi question thay đổi
    useEffect(() => {
        setIsShowResult(false);
        setAnswerList([]);
        setGivenList(
            createGivenList(splitAnswer(question.answer, question.confused)),
        );
        if (question.type === 'arrange-listening')
            if (handlePlay) handlePlay(question.answer[0]);
        // eslint-disable-next-line
    }, [question]);

    useEffect(() => {
        if (givenDivRef && givenDivRef.current) {
            // console.log('givenDivRef.current', givenDivRef.current);
            const bound = givenDivRef.current.getBoundingClientRect();
            // console.log('bound', bound);
            setAnswerHeight(bound.height);
        }
        // eslint-disable-next-line
    }, [givenDivRef.current]);

    useEffect(() => {
        return () => {
            if (handleStop)
                handleStop();
        };
        // eslint-disable-next-line
    }, [])

    return (
        <div {...rest} className={clsx(styles.question, className)}>
            <div className={clsx(styles.images)}>
                {question.images.map((image, index) => (
                    <img key={image} src={image} alt={image} />
                ))}
            </div>
            {question.type === 'arrange-listening' && (
                <div className={clsx(styles.audio)}>
                    <IconButton
                        status="primary"
                        className={clsx(styles.icon, 'primary')}
                        onClick={() => { if (handlePlay) handlePlay(question.answer[0]) }}
                    >
                        <i className="fa-solid fa-volume-high"></i>
                    </IconButton>
                    <IconButton
                        status="primary"
                        className={clsx(styles.icon)}
                        onClick={() => handlePlayByWords(question.answer[0])}
                    >
                        <i className="fa-solid fa-sleigh"></i>
                    </IconButton>
                </div>
            )}
            <div className={clsx(styles.content)}>
                <div
                    className={clsx(styles.text)}
                    dangerouslySetInnerHTML={{
                        __html: handleTextToHtml(question.content),
                    }}
                >
                    {/* {handleTextToHtml(question.content)} */}
                </div>
                <div
                    className={clsx(styles.answerWrapper)}
                    style={{
                        minHeight: `${answerHeight + 50}px`,
                    }}
                >
                    {answerList.map((ele) => {
                        return (
                            <ArrangeBox
                                key={ele.id}
                                box={ele}
                                onClick={() => handleOnClickAnswerBox(ele)}
                            />
                        );
                    })}
                </div>
                <div ref={givenDivRef} className={clsx(styles.givenWrapper)}>
                    {givenList.map((ele) => {
                        return (
                            <ArrangeBox
                                key={ele.id}
                                box={ele}
                                onClick={() => handleOnClickGivenBox(ele)}
                            />
                        );
                    })}
                </div>
            </div>
            {/* action */}
            {!isShowResult && (
                <div className={styles.action}>
                    <TextButton
                        // disable={
                        //     optionsBox.filter((box) => box.status === 'choosen')
                        //         .length === 0
                        // }
                        normal
                        onClick={handleOnClickCheck}
                    >
                        {t('check')}
                    </TextButton>
                </div>
            )}
            {/* result */}
            {isShowResult && (
                <ResultBox
                    hideAnswer={false}
                    question={question}
                    result={result}
                    handleOnClickContinue={handleOnClickContinue}
                />
            )}
        </div>
    );
}
export default forwardRef(ArrangeQuestion);
